var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'mb-8': !_vm.dense,
  }},[(_vm.showTitle)?_c('SectionTitle',{attrs:{"title":_vm.label}}):_vm._e(),_c('p',{staticClass:"display-1 text--primary mb-0",domProps:{"textContent":_vm._s(_vm.displayValue)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }